import { Fragment, type ReactNode } from 'react'

/**
 * Render a text template with simple Markdown-like markup as React nodes.
 *
 * Supports:
 *   {key}       — replaced with values[key]
 *   **text**    — rendered as <strong>text</strong>
 *   *text*      — rendered as <em>text</em>
 *
 * Designed for plain-text strings in `texts.ts` so non-developers can edit
 * UI text without touching JSX.
 */
/** Rendert nur das Inline-Markup (**fett**, *kursiv*) als React-Knoten. */
export function md(text: string): ReactNode {
  const parts = text.split(/(\*\*[^*]+\*\*|\*[^*]+\*)/g)
  return parts.map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return <strong key={i}>{part.slice(2, -2)}</strong>
    }
    if (part.startsWith('*') && part.endsWith('*') && part.length > 2) {
      return <em key={i}>{part.slice(1, -1)}</em>
    }
    return <Fragment key={i}>{part}</Fragment>
  })
}

export function fmt(template: string, values: Record<string, string | number> = {}): ReactNode {
  const filled = template.replace(/\{(\w+)\}/g, (_, key: string) =>
    values[key] === undefined ? '' : String(values[key]),
  )
  return md(filled)
}
